import { timePickerDefaultProps } from "@element-customer-plus/components/time-picker"
import { buildProps, definePropType } from "@element-customer-plus/utils"

import type { ExtractPropTypes } from "vue"
import type { IDatePickerType } from "../date-picker.type"
import type { HolidayData } from "./shared"

export const datePickerProps = buildProps({
  ...timePickerDefaultProps,
  /**
   * @description type of the picker
   */
  type: {
    type: definePropType<IDatePickerType>(String),
    default: "date",
  },
  holidays: {
    type: definePropType<HolidayData>(Object),
    default: () => ({}),
  },
} as const)

export type DatePickerProps = ExtractPropTypes<typeof datePickerProps>
